import { Component, Vue } from 'vue-property-decorator';
import { configYml } from '@/helpers/Environment';
import { imageUrlMaxWidth } from '@/helpers/ImageHelpers';
import { API } from '@/api/API';
import { isLoggedIn } from '@/state/Authentication';
@Component({ name: 'PendingOrdersRoute' })
export default class extends Vue {
    sellerMeta = {};
    cart;
    loading = true;
    $el;
    t;
    get referenceNumber() {
        return this.$t('pendingOrdersRoute.referenceNumber', { number: this.cart.cart_number });
    }
    get imageUrl() {
        const completedImage = configYml.componentOptions?.completedOrdersRoute?.completedImage ?? {};
        return {
            mobile: imageUrlMaxWidth(this.sellerMeta.completed_mobile_image) || completedImage.mobile,
            desktop: imageUrlMaxWidth(this.sellerMeta.completed_image) || completedImage.desktop,
        };
    }
    get contentOffset() {
        const completedContentOffset = configYml.componentOptions?.completedOrdersRoute?.completedContentOffset ?? {};
        return {
            mobile: this.sellerMeta.completed_content_mobile_offset || completedContentOffset.mobile,
            desktop: this.sellerMeta.completed_content_offset || completedContentOffset.desktop,
        };
    }
    created() {
        this.fetchCart()
            .then((response) => {
            if (response.ticket_order._count > 0) {
                this.$router.push({
                    name: 'checkout/complete',
                    query: {
                        orderIds: response.ticket_order._data.map((order) => order.id),
                    },
                });
            }
            return response.cart._data[0];
        })
            .then((cart) => {
            this.setCSSCustomProperties();
            this.cart = cart;
            this.loading = false;
        })
            .catch((error) => {
            if (error.response.status === 404) {
                return this.$notFound();
            }
            throw error;
        });
    }
    fetchCart() {
        const id = this.$route.params.cartId;
        const endpoint = isLoggedIn() ? `my/cart/${id}` : `cart/${id}`;
        return API.getUncached(endpoint, {
            embed: 'ticket_order',
            limit: 1000,
        });
    }
    setCSSCustomProperties() {
        // Wait for the next JavaScript turn so that the <Loader> has gone and the content is in place.
        setTimeout(() => {
            this.setCSSCustomProperty('--completed-offset', this.contentOffset.desktop);
            this.setCSSCustomProperty('--completed-mobile-offset', this.contentOffset.mobile);
        });
    }
    setCSSCustomProperty(name, value) {
        if (value != null) {
            this.$el.style.setProperty(name, value);
        }
    }
}
